import React from 'react';
import debounce from 'debounce';

import {
    Select
} from 'antd';

import {
    _getEntityIds
} from '../../services';

const { Option } = Select;

class SearchInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            entityIdList: []
        }

        this.handleSearch = debounce(this.handleSearch, 500);
    }

    render() {
        const options = this.state.entityIdList.map(d => <Option key={d.value} children={d.text}>{d.text}</Option>);
        return (
            <Select
                loading={this.props.loading}
                showSearch
                style={this.props.style}
                placeholder={this.props.placeholder}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                notFoundContent={null}
            >
                {options}
            </Select>
        )
    }

    getEntityIds = ( value ) => {
        _getEntityIds({ 
            entityType: this.props.entityType,
            searchTerm: value 
        })
        .then(_entityIdList => {
            this.setState({
                entityIdList: _entityIdList.data,
            })
        })
    }

    handleSearch = (value) => {
        if (value) {
            this.getEntityIds( value );
        } else {
            this.setState({ data: [] });
        }
    };

    handleChange = (value) => {
        this.props.onChange( value )
    };

}

export default SearchInput


// WEBPACK FOOTER //
// ./src/components/payment-advice/search-input.js